import { useRef, useState } from "react";
import { Button, Form } from "react-bootstrap";
import DatePicker from "react-datepicker";
import { CSVLink } from "react-csv";
import { useLazyQuery } from "@apollo/client";
import moment from "moment-timezone";
import { toast } from "react-toastify";

import QUERY from "../../utils/service/query";

const ExportCSVForm = () => {
  const [fromDate, setFromDate] = useState();
  const [toDate, setToDate] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [exportData, setExportData]: Array<any> = useState();
  const csvLinkRef = useRef<any>();

  const headers = [
    { label: "Date Reported", key: "reportedDate" },
    { label: "Time Reported", key: "reportedTime" },
    { label: "Reported By", key: "reporter" },
    { label: "Reportee", key: "reportee" },
    { label: "Total Reports", key: "totalReports" },
    // { label: "Clip Type", key: "clipType" },
    { label: "Reason", key: "reason" },
    { label: "Location Of The Clip", key: "clipLocation" },
    { label: "Status", key: "status" },
    { label: "Last Action Taken", key: "lastActionBy" },
    { label: "Reportee History", key: "reporteeHistory" },
  ];

  const [getData] = useLazyQuery(QUERY.REPORTS.EXPORT_CSV);

  const getExportData = async () => {
    if ((toDate || "") <= (fromDate || "")) {
      toast.dismiss();
      toast.error("Please select valid From and To date!");
    } else {
      setIsLoading(true);
      let dataTmp: Array<any> = [];
      (
        await getData({
          variables: {
            from: moment(fromDate)
              .tz("Australia/Brisbane")
              .format("MM/DD/YYYY"),
            to: moment(toDate).tz("Australia/Brisbane").format("MM/DD/YYYY"),
          },
        })
      ).data?.exportReports?.map((item: any) => {
        dataTmp.push({
          reportedDate:
            moment(item?.createdOn)
              .tz("Australia/Brisbane")
              .format("DD-MM-YYYY") || "",
          reportedTime:
            moment(item?.createdOn).tz("Australia/Brisbane").format("h:mm A") ||
            "",
          reporter: item?.reporter?.displayName || "",
          reportee: item?.reportee?.displayName || "",
          totalReports: item?.reportsCount || "",
          // clipType: item?.clipType || "",
          // clipType: "",
          reason:
            item?.reason ||
            (item?.otherText && `Other- ${item?.otherText}`) ||
            "N/A",
          clipLocation: item?.clipType || "",
          status: item?.status || "Active",
          lastActionBy: `${
            item?.lastActionByUser?.userProfile?.firstName ||
            item?.lastActionByUser?.userProfile?.lastName
              ? (item?.lastActionByUser?.userProfile?.firstName || "") +
                " " +
                (item?.lastActionByUser?.userProfile?.lastName || "") +
                ","
              : item?.lastActionByUser?.displayName
              ? item?.lastActionByUser?.displayName + ","
              : ""
          } ${
            item?.lastActionAt
              ? moment(item?.lastActionAt)
                  .tz("Australia/Brisbane")
                  .format("DD-MM-YYYY, h:mm A") || ""
              : ""
          }`,
          reporteeHistory: item?.reporteeHistory || "",
        });
      });
      setExportData(dataTmp);
      csvLinkRef.current.link.click();
      setIsLoading(false);
    }
  };
  return (
    <Form>
      <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
        <Form.Label>From Date</Form.Label>
        <DatePicker
          dateFormat="dd/MM/yyyy"
          selected={fromDate}
          onChange={(date: any) => setFromDate(date)}
          className="form-control form-control-md"
          placeholderText="DD/MM/YYYY"
        />
      </Form.Group>
      <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
        <Form.Label>To Date</Form.Label>
        <DatePicker
          dateFormat="dd/MM/yyyy"
          selected={toDate}
          onChange={(date: any) => setToDate(date)}
          className="form-control form-control-md"
          placeholderText="DD/MM/YYYY"
        />
      </Form.Group>
      {isLoading ? (
        <Button disabled>Loading</Button>
      ) : (
        <Button disabled={!fromDate || !toDate} onClick={() => getExportData()}>
          EXPORT
        </Button>
      )}

      <CSVLink
        style={{ visibility: "hidden" }}
        ref={csvLinkRef}
        data={exportData ?? ""}
        headers={headers}
        className="hidden"
        filename={`ideaclip-report.csv`}>
        EXPORT
      </CSVLink>
    </Form>
  );
};
export default ExportCSVForm;
